<template>
  <div>
    <Subheader title="Staff Maker Overview" />

    <div class="app-content-column">
      <div class="card">
        <h5>Search</h5>
        <input v-model="makersFilter.search" class="input" type="text" @input="refreshData" />
        <!-- <div class="button-wrapper">
          <button class="large-button" @click="refreshData">Search</button>
        </div>-->
      </div>

      <div class="card">
        <h5>Makers</h5>
        <Pagination
          style="margin: 1.25rem 0"
          :pagination-details="paginationDetails"
          :show-only-result-count="false"
          :hide-pages="true"
          @update="refreshData($event)"
        />
        <table>
          <tr>
            <th>Name</th>
            <th>Verified Projects</th>
            <th>Unverified Projects</th>
            <th>Activator</th>
            <th></th>
          </tr>
          <tr v-for="maker in makers" :key="maker.id">
            <td>{{ maker.fullName }}</td>
            <td>{{ maker.mVerifiedProjects.length }}</td>
            <td>{{ maker.mUnverifiedProjects.length }}</td>
            <td>
              {{ maker.mActivator ? maker.mActivator.username : 'No Activator Assigned' }}
              <font-awesome-icon
                v-if="maker.mActivator"
                icon="times"
                @click="removeActivator(maker.id, maker.mActivator.id)"
              />
            </td>
            <td>
              <button
                class="small-button small-button--inverted"
                @click="
                  toggleActivatorModal(maker.id, maker.mActivator ? maker.mActivator.id : null)
                "
              >
                {{ maker.mActivator ? 'Change Activator' : 'Add Activator' }}
                <br />
              </button>
            </td>
          </tr>
        </table>

        <Pagination
          style="margin: 1.25rem 0"
          :pagination-details="paginationDetails"
          :show-only-result-count="false"
          :hide-pages="true"
          @update="refreshData($event)"
        />
      </div>

      <div v-if="showActivatorModal" class="popup-overlay">
        <div class="popup-modal" style="overflow: scroll;">
          <div class="popup-close">
            <font-awesome-icon icon="times" @click="toggleActivatorModal" />
          </div>
          <h5>Search Activators</h5>
          <input
            v-model="activatorsFilter.search"
            class="input"
            placeholder="e.g. John Smith"
            @input="refreshData"
          />
          <div v-for="activator in activators" :key="activator.id" class="name-list">
            <span @click="selectModalActivator(activator.id)">{{ activator.username }}</span>
            <span v-if="activator.id === modalSelectedActivator">
              <font-awesome-icon icon="check"></font-awesome-icon>
            </span>
          </div>
          <div class="button-wrapper">
            <button
              v-if="modalSelectedActivator"
              class="table-btn"
              @click="assignActivator(modalMaker, modalSelectedActivator)"
            >
              Submit Activator
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/services/users'
import Subheader from '@/components/Subheader'

import Pagination from '@/components/Pagination'
import { getPaginationDataFromResponse } from '@/services/utils/pagination'

export default {
  name: 'StaffMakerOverview',
  components: {
    Subheader,
    Pagination,
  },
  data() {
    return {
      showActivatorModal: false,
      makersFilter: {
        isMaker: true,
      },
      activatorsFilter: {
        isActivator: true,
        search: '',
        // NRS 4.23.2020 -- This is a hack, but I am short on time!
        pageSize: 999999,
      },
      paginationDetails: {},
      makers: [],
      activators: [],
      modalSelectedActivator: null,
      modalMaker: null,
    }
  },
  created() {
    this.refreshData()
  },
  methods: {
    selectModalActivator(activatorId) {
      this.modalSelectedActivator = activatorId
    },
    toggleActivatorModal(makerId = null, existingActivator = null) {
      if (this.showActivatorModal) {
        this.showActivatorModal = false
        this.modalMaker = null
        this.modalSelectedActivator = null
        return
      } else {
        this.showActivatorModal = true
        this.modalMaker = makerId
        this.modalSelectedActivator = existingActivator
      }
    },
    assignActivator(makerId, activatorId) {
      User.api
        .addActivator(makerId, activatorId)
        .then(() => {
          this.refreshData()
        })
        .then(() => {
          if (this.showActivatorModal) {
            this.toggleActivatorModal()
          }
        })
    },
    removeActivator(makerId, activatorId) {
      User.api.removeActivator(makerId, activatorId).then(() => {
        this.refreshData()
      })
    },
    async refreshData(page = null) {
      let filtersWithPageCount = { ...this.makersFilter }
      if (page) {
        filtersWithPageCount = { ...this.makersFilter, page: page }
      }

      User.api.list({ filters: filtersWithPageCount }).then(data => {
        this.makers = data.results
        this.paginationDetails = getPaginationDataFromResponse(data)
      })
      User.api.list({ filters: this.activatorsFilter }).then(data => {
        this.activators = data.results
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/cards';
@import '../styles/mixins/containers';
@import '../styles/mixins/buttons';
@import '../styles/mixins/tables';
@import '../styles/mixins/popup';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
  align-items: center;
  margin-top: 1.25rem;
}

.name-list {
  padding: 0.5rem 0;
}

.table-btn {
  @include tag-button();
}

.bold-name {
  font-family: $base-bold-font-family;
  list-style-type: none;
  padding-bottom: 0.5rem;
}
</style>
